import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmationDialogComponent } from '../../../../../shared/components/confirmation-dialog/confirmation-dialog.component';
import { take } from 'rxjs/internal/operators/take';

@Component({
	selector: 'app-transcriptions-toolbar',
	standalone: true,
	imports: [MatToolbarModule, MatButtonModule, MatTooltipModule, MatIconModule, TranslateModule],
	templateUrl: './transcriptions-toolbar.component.html',
	styleUrl: './transcriptions-toolbar.component.scss'
})
export class TranscriptionsToolbarComponent {
	@Input() selectedItems: any[] = [];
	@Input() totalItemsCount: number = 0;
	@Input() scrollToTop: boolean = false;
	@Output() actionRequested: EventEmitter<any> = new EventEmitter();

	constructor(private matDialog: MatDialog) {}

	checkValidity(type: 'DELETE') {
		switch (type) {
			case 'DELETE': {
				return this.selectedItems.length > 0;
			}
			default:
				return false;
		}
	}

	itemAction(action: 'DELETE' | 'UNSELECT_ALL' | 'SCROLL_TO_TOP') {
		switch (action) {
			case 'DELETE': {
				// This component only ever renders for the client (client/components/data-preview/...),
				// so the SETTE panelClass (CLIPPING-600 Phase 3 Step 3) applies unconditionally.
				const dialogRef = this.matDialog.open(ConfirmationDialogComponent, {
					width: '600px',
					panelClass: 'confirmation-dialog-panel--client',
					data: {
						type: 'delete-confirmation',
						mode: 'DELETE',
					},
				});
			
				dialogRef
					.afterClosed()
					.pipe(take(1))
					.subscribe(result => {
						if (result) {
							this.actionRequested.next({
								action: 'TOOLBAR',
								groupAction: action
							});
						}
					});
				break;
			}
			case 'UNSELECT_ALL': {
				this.actionRequested.emit({
					action: 'UNSELECT_ALL',
				});
				break;
			}
			case 'SCROLL_TO_TOP': {
				this.actionRequested.emit({
					groupAction: 'SCROLL_TO_TOP'
				});
				break;
			}
		}
	}

	scrollToTopAction() {
		this.actionRequested.emit({
			groupAction: 'SCROLL_TO_TOP'
		});
	}
}